import { render, staticRenderFns } from "./DetailCamusSliderNews.vue?vue&type=template&id=7749c8d0"
import script from "./DetailCamusSliderNews.vue?vue&type=script&lang=js"
export * from "./DetailCamusSliderNews.vue?vue&type=script&lang=js"
import style0 from "./DetailCamusSliderNews.vue?vue&type=style&index=0&id=7749c8d0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports